import { useRiskReturnPage } from "@iliotech/data-wire";
import RiskVsReturnTable from "src/components/__consumerCharts/RiskVsReturnScatter/RiskVsReturnTable";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const RiskReturnTableWidget = ({ periodContext }: ReportWidgetProps) => {
  const { tableData } = useRiskReturnPage(periodContext);
  return (
    <div>
      <h6 className={"element-title"}>{`Risk Return Table`}</h6>
      <RiskVsReturnTable data={tableData} />
    </div>
  );
};
